import { render, staticRenderFns } from "./FormReceipt.vue?vue&type=template&id=f4da57f6&scoped=true&"
import script from "./FormReceipt.vue?vue&type=script&lang=js&"
export * from "./FormReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4da57f6",
  null
  
)

export default component.exports